import React from "react";
import BreadCrumb from "Common/BreadCrumb";

import useInvoice from "hooks/useInvoice";
import { InvoiceCard } from "Common/Components/InvoiceCard";
import { useSearchParams } from "react-router-dom";

const Invoice = () => {
  const searchParams = useSearchParams()[0];

  const bookingId = searchParams.get("booking");

  const { isLoading, data } = useInvoice(bookingId ?? "");

  return (
    <React.Fragment>
      <BreadCrumb
        pageTitle="Invoices"
        title={`Invoice #${data?.data?.invoiceNumber ?? ""}`}
      />

      <div className=" my-8 px-4 w-full lg:max-w-[70%] bg-white rounded-md py-8">
        {isLoading ? <p>Loading..</p> : <InvoiceCard invoice={data?.data!} />}
      </div>
    </React.Fragment>
  );
};

export default Invoice;
